// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3C7VV","selects":"Documents_selects___TAGl"};